/* defaultName is assumed to be a string without numerals at the end */
export const autoIncrementedName = (defaultName: string, names: string[]) => {
  let counter = 1;
  let name = `${defaultName} ${counter}`;

  // eslint-disable-next-line no-loop-func
  while (names.find(n => n === name)) {
    counter += 1;
    name = `${defaultName} ${counter}`;
  }

  return name;
};
